import { render } from "./WindowNotes.vue?vue&type=template&id=29881a38&scoped=true"
import script from "./WindowNotes.vue?vue&type=script&lang=js"
export * from "./WindowNotes.vue?vue&type=script&lang=js"

import "./WindowNotes.vue?vue&type=style&index=0&id=29881a38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29881a38"

export default script